import { useMemo } from 'react';

/**
 * Custom hook to check if the application is in maintenance mode.
 * Reads the maintenance mode status from environment variables.
 * @returns A boolean indicating whether maintenance mode is active.
 */
const useMaintenanceMode = () => {
  const isMaintenanceMode = useMemo(() => {
    return import.meta.env.VITE_MAINTENANCE_MODE === 'true';
  }, []);

  return isMaintenanceMode;
};

export default useMaintenanceMode;
